/**
    * @description      :
    * @author           :
    * @group            :
    * @created          : 26/08/2021 - 12:55:43
    *
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 26/08/2021
    * - Author          :
    * - Modification    :
**/
import * as React from "react"

const Delete = (props) => {
  return (
    <svg
      width={11}
      height={15}
      viewBox="0 0 11 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.05 3.6V2.3A1.3 1.3 0 014.35 1h2.6a1.3 1.3 0 011.3 1.3v1.3m1.95 0v9.1A1.3 1.3 0 018.9 14H2.4a1.3 1.3 0 01-1.3-1.3V3.6h9.1z"
        stroke="#24A95D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default React.memo(Delete)
